import type { ComputedRef, Ref } from 'vue'

import { computed, ref } from 'vue'

export default (errorValue: Ref<string | string[]>): ComputedRef<string[]> => {
  const err = ref(errorValue)

  return computed(() =>
    Array.isArray(err.value) ? err.value : err.value ? [err.value] : []
  )
}
